import _taggedTemplateLiteral from "@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _templateObject;
import React from 'react';
import { Input, Header, /* Image, */Message, Button, Form, Modal, Divider } from 'semantic-ui-react';
import { withFormik } from 'formik';
import gql from 'graphql-tag';
import { graphql } from 'react-apollo';
import compose from 'lodash/flowRight';
import { AuthClient, EnjoyIcon } from '@emyw/core-lib';
import { normalizeErrors } from '../utils';
import ButtonLink from '../ButtonLink';
import '../primitives.css';
const {
  REACT_APP_ENJOY_SITE_ROOT_URL
} = process.env;
const ForgotPasswordLogic = withFormik({
  validateOnBlur: false,
  validateOnChange: false,
  // Transform outer props into form values
  mapPropsToValues: () => ({
    email: ''
  }),
  // Add a custom validation function
  validate: values => {
    const errors = {};
    // Email
    if (!values.email) {
      errors.email = 'Email required';
    } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,10}$/i.test(values.email)) {
      errors.email = 'Invalid email address';
    }
    return errors;
  },
  // Submission handler
  handleSubmit: async (values, _ref) => {
    let {
      props: {
        mutate
      },
      setSubmitting,
      setStatus,
      setErrors
    } = _ref;
    const response = await mutate({
      variables: {
        email: values.email,
        origin: REACT_APP_ENJOY_SITE_ROOT_URL
      }
    });
    const {
      ok,
      errors
    } = response.data.sendResetPasswordLink;
    if (ok) {
      setStatus('showSubmittedMessage');
    } else {
      setErrors(normalizeErrors(errors, 'email'));
    }
    setSubmitting(false);
  }
});

/** Forgot Password Form is intended as a general purpose forgot password page or dialog
 * <br /><br />
 * <hr />
 * <br />
 * <div>
 * <h4>Back-end Requirements</h4>
 * A backend graphql api endpoint with the sendResetPasswordLink mutation,
 * <a rel=noopener href="https://github.com/emyw/auth-api">auth-api</a>,
 * is needed for this form to function.
 * <h4>Forgot Password</h4>
 * The user is prompted to provide an email address that is already registered with the system.
 * If the email matches an existing user, an email is sent to that address with a time expiring link.<br />
 * Upon successful response from the server that the email was sent, this component shows a message sent
 * message with an OK button that redirects them back to the login page, or closes the dialog.<br /><br />
 * Once the user receives the email and clicks the link, it directs them to the reset password component.
 * </div>
 */
const ForgotPasswordForm = _ref2 => {
  let {
    values,
    handleChange,
    handleBlur,
    handleSubmit,
    isSubmitting,
    touched,
    errors,
    onClose,
    onLogin,
    status,
    onSuccess
  } = _ref2;
  const Wrapper = props => props.children;
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Header, {
    color: "blue",
    attached: "top"
  }, /*#__PURE__*/React.createElement(EnjoyIcon, {
    className: "formTitleIcon"
  }), " \xA0 Forgot Password"), /*#__PURE__*/React.createElement(Header, {
    block: true,
    attached: "bottom",
    as: "h5"
  }, "You can reset your password by providing your email address."), /*#__PURE__*/React.createElement(Divider, {
    hidden: true
  }), /*#__PURE__*/React.createElement(Form, null, /*#__PURE__*/React.createElement(Form.Field, {
    error: !!errors.email
  }, /*#__PURE__*/React.createElement(Input, {
    name: "email",
    id: "email",
    onChange: handleChange,
    onBlur: handleBlur,
    value: values.email,
    icon: "mail",
    iconPosition: "left",
    placeholder: "Email",
    fluid: true
  })), /*#__PURE__*/React.createElement(Divider, {
    hidden: true
  }), /*#__PURE__*/React.createElement(Form.Field, {
    style: {
      textAlign: 'center'
    }
  }, /*#__PURE__*/React.createElement(Button, {
    className: "square",
    type: "submit",
    disabled: isSubmitting,
    onClick: handleSubmit,
    size: "large",
    primary: true,
    fluid: true,
    style: {
      margin: '0px auto',
      maxWidth: '300px'
    }
  }, "SUBMIT")), /*#__PURE__*/React.createElement(Form.Field, {
    style: {
      textAlign: 'center'
    }
  }, "Remember password?", /*#__PURE__*/React.createElement(ButtonLink, {
    color: "blue",
    onClick: () => {
      if (onLogin) onLogin();else log.warn('onLogin prop required but not provided');
      onClose();
    }
  }, "\xA0\xA0Log in"))), touched.email && errors.email && /*#__PURE__*/React.createElement(Wrapper, null, /*#__PURE__*/React.createElement(Divider, {
    hidden: true
  }), /*#__PURE__*/React.createElement(Message, {
    size: "small",
    error: true
  }, /*#__PURE__*/React.createElement(Message.Header, null, "Trouble attempting to reset password:"), /*#__PURE__*/React.createElement("p", null, errors.email))), /*#__PURE__*/React.createElement(Modal, {
    open: status === 'showSubmittedMessage',
    size: "mini",
    className: "enjoyModal"
  }, /*#__PURE__*/React.createElement(Modal.Header, null, "Email Sent!"), /*#__PURE__*/React.createElement(Modal.Content, null, /*#__PURE__*/React.createElement("p", null, "Once received, click the provided link to reset your password."), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement(Button, {
    type: "button",
    onClick: () => {
      if (onSuccess) onSuccess();else log.warn('onSuccess prop required but not provided');
      if (onClose) onClose();
    },
    basic: true,
    color: "blue",
    fluid: true
  }, "OK"))));
};
const forgotPasswordMutation = gql(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    mutation ($email: String!, $origin: String!) {\n        sendResetPasswordLink(email: $email, origin: $origin) {\n            ok\n            errors {\n                path\n                message\n            }\n        }\n    }\n"])));
ForgotPasswordForm.defaultProps = {
  onClose: () => null
};
export default compose(graphql(forgotPasswordMutation, {
  client: AuthClient
}), ForgotPasswordLogic)(ForgotPasswordForm);